
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/native-delivery/sms",
      function () {
        return require("private-next-pages/native-delivery/sms.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/native-delivery/sms"])
      });
    }
  